import PlanCard from "./PlanCard";
import ActionInformationText from "./ActionInformationText";
import ContactSalesFormWithButton from "../ContactSalesFormWithButton";

export default function EnterprisePlanCard() {
  const ActionButton = () => {
    return <ContactSalesFormWithButton largeButton />;
  };

  const ActionInformation = () => {
    return <ActionInformationText text="" />;
  };

  return (
    <>
      <PlanCard
        name="Enterprise"
        price="500+"
        description="We offer custom pricing for large orders."
        tag="per month, custom pricing."
        actionInformation={<ActionInformation />}
        actionButton={<ActionButton />}
        displayCurrencyName={false}
      />
    </>
  );
}
